import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8a00986"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderCard" }
const _hoisted_2 = { class: "OrderCard__header" }
const _hoisted_3 = { class: "header__title font-medium text-xl" }
const _hoisted_4 = { class: "header__sector" }
const _hoisted_5 = { class: "OrderCard__container mt-3" }
const _hoisted_6 = { class: "container__text" }
const _hoisted_7 = { class: "container__text" }
const _hoisted_8 = { class: "container__text" }
const _hoisted_9 = { class: "container__text mt-2" }
const _hoisted_10 = { class: "container__text" }
const _hoisted_11 = { class: "container__text mt-2" }
const _hoisted_12 = { class: "container__text" }
const _hoisted_13 = { class: "container__text" }
const _hoisted_14 = { class: "container__text" }
const _hoisted_15 = { class: "container__text" }
const _hoisted_16 = { class: "container__text mt-2" }
const _hoisted_17 = { class: "container__text" }
const _hoisted_18 = { class: "OrderCard__actions mt-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-day mr-2" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shipping-fast mr-2" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo mr-2" }, null, -1))
const _hoisted_22 = {
  key: 0,
  class: "OrderCard__newdate mt-6 pt-6"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Смена даты забора", -1))
const _hoisted_24 = { class: "flex items-center justify-between mt-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_27 = { class: "mt-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-3" }, "График работы компании", -1))
const _hoisted_29 = { class: "mt-3 grid grid-cols-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-2" }, "Забор", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-2" }, "Доставка", -1))
const _hoisted_32 = {
  key: 0,
  class: "container__text text-gray-400 text-sm"
}
const _hoisted_33 = { class: "OrderCard__takes" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-3" }, "Накладные", -1))
const _hoisted_35 = { class: "flex justify-between w-full mb-3" }
const _hoisted_36 = {
  key: 1,
  class: "text-gray-400 flex justify-center items-center flex-col select-none"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Выберите заказ в списке, для детального просмотра", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mt-3" }, null, -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_order_card_statuses_line = _resolveComponent("order-card-statuses-line")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.item)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item.order_id), 1),
            _createElementVNode("span", _hoisted_4, [
              (_ctx.item.sector)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.item.sector.name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Сектор не указан ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, "Компания: " + _toDisplayString(_ctx.item.company_name), 1),
            _createElementVNode("p", _hoisted_7, "Адрес: " + _toDisplayString(_ctx.item.full_address), 1),
            _createElementVNode("p", _hoisted_8, "Номер 1С: " + _toDisplayString(_ctx.item.number_1c), 1),
            _createElementVNode("p", _hoisted_9, "Контактное лицо: " + _toDisplayString(_ctx.item.full_name), 1),
            _createElementVNode("p", _hoisted_10, "Контактный телефон: " + _toDisplayString(_ctx.item.phone), 1),
            _createElementVNode("span", _hoisted_11, [
              (_ctx.item.period_title.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Период забора: "),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.period_title, (period_title, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `title-${i}`
                      }, [
                        (i !== 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(", ")
                            ], 64))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(period_title), 1)
                      ], 64))
                    }), 128))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Период забора: Нет данных ")
                  ], 64))
            ]),
            _createElementVNode("span", _hoisted_12, " Комментарий отправителя: " + _toDisplayString(_ctx.item.sender_comment || 'Нет данных'), 1),
            _createElementVNode("span", _hoisted_13, " Общее количество мест: " + _toDisplayString(_ctx.item.totalPlaces), 1),
            _createElementVNode("span", _hoisted_14, " Общий физический вес: " + _toDisplayString(_ctx.item.totalWeight), 1),
            _createElementVNode("span", _hoisted_15, " Доп. услуги: " + _toDisplayString(_ctx.getAdditionalInfo || 'Нет данных'), 1),
            (Boolean(_ctx.item.courier))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", _hoisted_16, "Курьер: " + _toDisplayString(_ctx.item.courier.full_name), 1),
                  _createElementVNode("p", _hoisted_17, "Телефон курьера: " + _toDisplayString(_ctx.item.courier.phone_number), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.isCanChangeDate)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 0,
                  class: "text primary small",
                  onClick: _ctx.startChangeDate
                }, {
                  default: _withCtx(() => [
                    _hoisted_19,
                    _createTextVNode(" Перенести дату ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_the_button, {
              class: "text primary small",
              onClick: _ctx.emitStartSubmitOrder
            }, {
              default: _withCtx(() => [
                _hoisted_20,
                _createTextVNode(" Выдать заказ курьеру ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_the_button, {
              class: "text primary small",
              onClick: _ctx.emitRefresh
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _createTextVNode(" Обновить ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          (_ctx.state.is_changing_date)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_the_input, {
                  class: "mt-3",
                  type: "date",
                  value: _ctx.state.new_date,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.new_date) = $event)),
                  "is-invalid": _ctx.state_form$.new_date.$error,
                  "validation-errors": _ctx.state_form$.new_date.$errors,
                  placeholder: "Укажите новую дату забора"
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_select, {
                  class: "mt-3",
                  placeholder: "Период отправки",
                  value: _ctx.state.periodId,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.periodId) = $event)),
                  loading: _ctx.data_state.periods.is_loading,
                  failed: _ctx.data_state.periods.is_failed,
                  "error-text": "При получении списка периодов произошла ошибка",
                  searchable: false,
                  options: _ctx.data_state.periods.list,
                  onRefresh: _ctx.loadPeriods,
                  label: "title"
                }, null, 8, ["value", "loading", "failed", "options", "onRefresh"]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_the_button, {
                    class: "text second small",
                    onClick: _ctx.cancelChangeDate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25,
                      _createTextVNode(" Отмена ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_the_button, {
                    class: "text primary small",
                    loading: _ctx.state.is_loading,
                    onClick: _ctx.changeDate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26,
                      _createTextVNode(" Подтвердить ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", null, [
                _hoisted_30,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getScheduleStrFinal(_ctx.schedule_take), (schedule) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "container__text text-sm",
                    key: schedule.id
                  }, _toDisplayString(schedule), 1))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _hoisted_31,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getScheduleStrFinal(_ctx.schedule_delivery), (schedule) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "container__text text-sm",
                    key: schedule.id
                  }, _toDisplayString(schedule), 1))
                }), 128))
              ])
            ]),
            (_ctx.item.company_schedule.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_32, " График работы компании не указан "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_order_card_statuses_line, {
            class: "mt-3",
            statuses: _ctx.item.status_history
          }, null, 8, ["statuses"]),
          (_ctx.item.states.length > 0)
            ? (_openBlock(), _createBlock(_component_cheap, {
                key: 1,
                class: "primary small mt-2"
              }, {
                default: _withCtx(() => [
                  (Boolean(_ctx.item.courier))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.item.courier.full_name), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" (" + _toDisplayString(_ctx.item.states[_ctx.item.states.length - 1].title) + " " + _toDisplayString(_ctx.item.states[_ctx.item.states.length - 1].date) + ") ", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.item.wait_list_status)
            ? (_openBlock(), _createBlock(_component_cheap, {
                key: 2,
                class: "primary small mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.item.wait_list_status), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.takes, (take) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `take-${take.id}`,
                class: "invoice"
              }, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", null, "Накладная (ID): " + _toDisplayString(take.invoice_id), 1),
                  _createVNode(_component_cheap, {
                    class: _normalizeClass(["small mr-2 w-max", {
                                red: take.status === 'not_assigned',
                                primary: take.status === 'assigned_to_courier',
                                green: take.status === 'cargo_handling',
                                yellow: take.status === 'taken',
                            }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.DispatcherOrderStatusesEnum[take.status]), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _createElementVNode("span", null, "Номер накладной: " + _toDisplayString(take.invoice_number), 1),
                _createElementVNode("span", null, "Направление: " + _toDisplayString(take.direction), 1)
              ]))
            }), 128))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_39))
  ]))
}